<p class="text-muted">Bonjour, <b>Emilio Verdines!</b> 
    <br/>Bienvenue sur votre Tableau de bord.</p>
    
<div fxLayout="row wrap" class="flex-wrapper">
    <div fxFlex="100" fxFlex.gt-sm="33.3" fxFlex.sm="50" class="p-3">
        <div class="bordered px-3 py-2">
            <div fxLayoutAlign="space-between center">
                <h4 class="secondary-font">Mes Informations</h4> 
                <a mat-icon-button routerLink="/account/monprofile"><mat-icon class="text-muted">edit</mat-icon></a>
            </div>
            <div class="divider"></div>
            <div class="pt-3">
                <p><a routerLink="/account/monprofile" class="primary-color fw-500">modifier mon profile</a></p>
            </div>
            <div class="pt-3">
                <p><a routerLink="/account/password-change" class="primary-color fw-500">Changer le mot de passe</a></p>
            </div>
        </div>
    </div>
    <div fxFlex="100" fxFlex.gt-sm="33.3" fxFlex.sm="50" class="p-3">
        <div class="bordered px-3 py-2">
            <div fxLayoutAlign="space-between center">
                <h4 class="secondary-font">Mes Parametres</h4> 
                <a mat-icon-button routerLink="/account/preference"><mat-icon class="text-muted">edit</mat-icon></a>
            </div>
            <div class="divider"></div>
            <div class="pt-3">
                <p><a routerLink="/account/verification" class="primary-color fw-500">Verifier mon idendité</a></p>
            </div>
            <div class="pt-3">
                <p><a routerLink="/account/validation" class="primary-color fw-500">Enregistrer mon permis</a></p>
            </div>
        </div> 
    </div>

    <div fxFlex="100" fxFlex.gt-sm="33.3" fxFlex.sm="50" class="p-3">
        <div class="bordered px-3 py-2">
            <div fxLayoutAlign="space-between center">
                <h4 class="secondary-font">Mes Vehicules</h4> 
                <a mat-icon-button routerLink="/account/cars"><mat-icon class="text-muted">add</mat-icon></a>
            </div>
            <div class="divider"></div>
            <div class="pt-3">
                <p><a routerLink="/account/verification" class="primary-color fw-500">Gerer mes vehicules</a></p>
            </div>
            <div class="pt-3">
                <p><a routerLink="/account/validation" class="primary-color fw-500">Mes disponibilités</a></p>
            </div>
        </div> 
    </div>

    <div fxFlex="100" fxFlex.gt-sm="33.3" fxFlex.sm="50" class="p-3">
        <div class="bordered px-3 py-2">
            <div fxLayoutAlign="space-between center">
                <h4 class="secondary-font">Mes Locations</h4> 
                <a mat-icon-button routerLink="/account/cars"><mat-icon class="text-muted">add</mat-icon></a>
            </div>
            <div class="divider"></div>
            <div class="pt-3">
                <p><a routerLink="/account/verification" class="primary-color fw-500">En tant que locataire</a></p>
            </div>
            <div class="pt-3">
                <p><a routerLink="/account/validation" class="primary-color fw-500">En tant que propriétaire</a></p>
            </div>
        </div> 
    </div>

    <div fxFlex="100" fxFlex.gt-sm="33.3" fxFlex.sm="50" class="p-3">
        <div class="bordered px-3 py-2">
            <div fxLayoutAlign="space-between center">
                <h4 class="secondary-font">Mon Porte monnaie</h4> 
                <a mat-icon-button routerLink="/account/cars"><mat-icon class="text-muted">attach_money</mat-icon></a>
            </div>
            <p> Vous disposer de </p> <h2> 100 Franc CFA </h2>
            <div class="divider"></div>
            <div class="pt-3">
                <p><a routerLink="/account/verification" class="primary-color fw-500">Mes depenses</a></p>
            </div>
            <div class="pt-3">
                <p><a routerLink="/account/validation" class="primary-color fw-500">Mes benefices</a></p>
            </div>
        </div> 
    </div>


    <!-- <div fxFlex="100" fxFlex.gt-sm="33.3" fxFlex.sm="50" class="p-3">
        <div class="bordered px-3 py-2">
            <div fxLayoutAlign="space-between center">
                <h2 class="secondary-font">Orders</h2> 
                <a mat-icon-button routerLink="/account/orders"><mat-icon class="text-muted">edit</mat-icon></a>
            </div>
            <div class="divider"></div>
            <div class="pt-3">
                <p class="">Completed</p>
                <mat-progress-bar value="75" color="primary"></mat-progress-bar>
                <p class="mt-1">Processing</p>
                <mat-progress-bar value="25" color="accent"></mat-progress-bar>
                <p class="mt-1">On hold</p>
                <mat-progress-bar value="65" color="warn"></mat-progress-bar>
                <p class="mt-1">Refunded</p>
                <mat-progress-bar value="25" color="primary"></mat-progress-bar>
            </div>
        </div>  
    </div> -->
</div>